import React from 'react'
import classNames from 'classnames'

import { AnnouncementBarProps } from './AnnouncementBar.types'
import { isAnnouncementClosed, setAnnouncementClosedInStorage } from './AnnouncementBar.utils'

export const AnnouncementBar = ({ className, id, text, link, theme }: AnnouncementBarProps) => {
  const [closed, setClosed] = React.useState(() => id != undefined && isAnnouncementClosed(id))

  const close = () => {
    setClosed(true)
    if (id != undefined) setAnnouncementClosedInStorage(id)
  }

  return (
    <div className={classNames(
      'announcement-bar', 
      'text--s',
      className, 
      { 
        [`announcement-bar--${theme}`] : theme,
        'announcement-bar--closed': closed,
      }
    )}>
      <div className="container announcement-bar__inner">
        <p>
          {text}{' '}
          {link && <a href={link.url}>{link.title}</a>}
        </p>
        <button className="announcement-bar__close" onClick={close}>
          <span className="sr-text">Sluit melding</span>
          <svg className="announcement-bar__icon" width="10" height="10" aria-hidden="true">
            <use xlinkHref="#icon--close" />
          </svg>
        </button>
      </div>
    </div>
  )
}